// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useState, useRef } from "react";
import { View, Text, TouchableOpacity, TextInput } from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import NextTransportStyle from "../../../../styles/Farmer/NextTransportStyle";
import DatePickerLabel from "./Elements/Labels/DataPickerLabel";
import colors from "../../../../config/colors";
import NumberSelector from "./Elements/NumberSelector";
import styles from "../../../../styles/Farmer/OwnStorageStyle";
import { updateOwnStorage } from "../../../../axios/axiosConfig";
import { useNavigation } from "@react-navigation/native";
import { Input } from "react-native-elements";

const StorageCard = ({
    onShowSnackbar,
    getTranslation,
    qta,
    capacità,
    bathtubName,
    depositId,
    alertMessage,
    handleToggleNestedCollapse,
    fetchData,
    isFromNewRequestCard,
}) => {
    const [isEditable, setEditable] = useState(false);
    const [quantity, setQuantity] = useState(qta);
    const [collapsed, setCollapsed] = useState(false);
    const quantityInputRef = useRef(null);

    const navigation = useNavigation();
    const handleModify = () => {
        setEditable(true);
    };

    const handleSubmit = async () => {
        setEditable(false);
        try {
            const response = await updateOwnStorage(depositId, quantity);
            if (response.status === 200) {
                onShowSnackbar(
                    getTranslation("Valore aggiornato correttamente"),
                    colors.green
                );
                if (isFromNewRequestCard) {
                    navigation.navigate(getTranslation("Movimenti"), {
                        from: "TruckTripsScreen",
                    });
                }
                fetchData();
            } else {
                onShowSnackbar(
                    getTranslation(response.response.data),
                    colors.red
                );
            }
        } catch (error) {
            onShowSnackbar(getTranslation("Errore di aggiornamento"), colors.red);
        }
    };

    const handleNumberChange = (value) => {
        setQuantity(value);
    };

    const handleCollapseToggle = () => {
        setCollapsed((prev) => !prev);
        if (handleToggleNestedCollapse) {
            handleToggleNestedCollapse();
        }
    };

    const texts = {
        Capacity: "Capacità totale (m³)",
        Quantity: "Q. Attuale (m³)",
        Confirm: "Conferma",
        Modify: "Modifica",
        Collapse: collapsed ? "Espandi" : "Comprimi",
    };

    return (
        <View
            style={[
                styles.content,
                {
                    backgroundColor: colors.white,
                    borderRadius: 16,
                    shadowColor: colors.white,
                },
            ]}
        >
            {alertMessage === null && (
                <View
                    style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        backgroundColor: colors.green,
                        borderRadius: 10,
                        paddingHorizontal: 8,
                        paddingVertical: 4,
                    }}
                >
                    <Text style={{ color: colors.white, fontWeight: "bold" }}>
                        {getTranslation("Confermato")}
                    </Text>
                </View>
            )}
            <View style={styles.rowContainer}>
                <Text
                    style={[
                        styles.label,
                        {
                            color: colors.green,
                            fontWeight: "bold",
                        },
                    ]}
                >
                    {bathtubName}
                </Text>
                <TouchableOpacity
                    onPress={handleCollapseToggle}
                    style={{ marginLeft: 8 }}
                >
                    <FontAwesome
                        name={collapsed ? "chevron-down" : "chevron-up"}
                        size={24}
                        color={colors.green}
                    />
                </TouchableOpacity>
            </View>
            {!collapsed && (
                <>
                    <View style={styles.rowContainer}>
                        <View style={styles.labelContainer}>
                            <Text style={styles.label}>{getTranslation(texts.Capacity)}</Text>
                        </View>
                        <View style={styles.inputContainer}>
                            <TextInput
                                style={[
                                    styles.input,
                                    {
                                        flex: 1,
                                        marginLeft: 8,
                                        color: colors.green,
                                        fontWeight: "bold",
                                        fontSize: 40,
                                        textAlign: "center",
                                        width: 180,
                                        height: 180,
                                    },
                                ]}
                                value={String(capacità)}
                                editable={false}
                            />
                        </View>
                    </View>
                    {isEditable ? (
                        <View style={NextTransportStyle.rowContainer}>
                            <View style={NextTransportStyle.labelContainer}>
                                <Text style={NextTransportStyle.label}>
                                    {getTranslation(texts.Quantity)}
                                </Text>
                            </View>
                            <View style={NextTransportStyle.inputContainer}>
                                <TextInput
                                    style={NextTransportStyle.customInput}
                                    placeholder={"_____________"}
                                    value={quantity == qta ? "" : quantity}
                                    keyboardType="numeric"
                                    onChangeText={handleNumberChange}
                                    ref={quantityInputRef}
                                    maxLength={4}
                                    required
                                />
                            </View>
                        </View>
                    ) : (
                        <View style={NextTransportStyle.rowContainer}>
                            <View style={NextTransportStyle.labelContainer}>
                                <Text style={NextTransportStyle.label}>
                                    {getTranslation(texts.Quantity)}
                                </Text>
                            </View>
                            <View style={NextTransportStyle.inputContainer}>
                                <DatePickerLabel type={"quantity"} quantity={quantity} />
                            </View>
                        </View>
                    )}
                    <View style={styles.buttonContainer}>
                        <View style={{ flexDirection: "row" }}>
                            <TouchableOpacity
                                onPress={handleSubmit}
                                style={[
                                    styles.button,
                                    {
                                        flex: 1,
                                        marginRight: 8,
                                        backgroundColor: colors.violet,
                                        borderRadius: 16,
                                    },
                                ]}
                            >
                                <View style={{ flexDirection: "row", alignItems: "center" }}>
                                    <FontAwesome
                                        name="check"
                                        size={24}
                                        color={colors.white}
                                        style={{ marginRight: 8 }}
                                    />
                                    <Text style={[styles.buttonText, { textAlign: "center" }]}>
                                        {getTranslation(texts.Confirm)}
                                    </Text>
                                </View>
                            </TouchableOpacity>
                            <TouchableOpacity
                                onPress={handleModify}
                                style={[
                                    styles.button,
                                    {
                                        flex: 1,
                                        marginLeft: 8,
                                        backgroundColor: colors.violet,
                                        borderRadius: 16,
                                    },
                                ]}
                            >
                                <View style={{ flexDirection: "row", alignItems: "center" }}>
                                    <FontAwesome
                                        name="pencil"
                                        size={24}
                                        color={colors.white}
                                        style={{ marginLeft: 8 }}
                                    />
                                    <Text
                                        style={[
                                            styles.buttonText,
                                            { textAlign: "center", marginLeft: 8 },
                                        ]}
                                    >
                                        {getTranslation(texts.Modify)}
                                    </Text>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </View>
                </>
            )}
        </View>
    );
};

export default StorageCard;
